import React from "react";
import "./Browse.css";
import NavBar from "../../components/browse/NavBar";
import Banner from "../../components/browse/Banner";
import MovieList from "../../components/browse/MovieList";
import requests from "../../utils/requests";
function Browse() {
  return (
    <div className="app">
      <NavBar />
      <Banner />
      <MovieList
        title=""
        poster_path
        fetchUrl={requests.fetchNetflixOriginals}
      />
      <MovieList title="Xu Hướng" fetchUrl={requests.fetchTrending} />
      <MovieList title="Xếp Hạng Cao" fetchUrl={requests.fetchTopRated} />
      <MovieList title="Hành Động" fetchUrl={requests.fetchActionMovies} />
      <MovieList title="Hài" fetchUrl={requests.fetchComedyMovies} />
      <MovieList title="Kinh Dị" fetchUrl={requests.fetchHorrorMovies} />
      <MovieList title="Lãng Mạn" fetchUrl={requests.fetchRomanceMovies} />
      <MovieList title="Tài Liệu" fetchUrl={requests.fetchDocumentaries} />
    </div>
  );
}

export default Browse;
